export default __webpack_public_path__ + "static/media/bernice-img.865cfa24.png";